import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { VehicleApiService } from '../../api/vehicle-api.service';
import { actions } from './hyundai-promise-vm.actions';

@Injectable()
export class PageContentVMEffects {
    protected readonly actions$ = inject(Actions);
    protected readonly store = inject(Store);
    protected readonly vehicleApi = inject(VehicleApiService);

    loadHyundaiPromiseVM$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.loadHyundaiPromiseVM),
            switchMap(() => {
                return from(this.vehicleApi.getPagePromise()).pipe(
                    map((content) => actions.loadHyundaiPromiseVMSuccess({ content })),
                    catchError((error) => of(actions.loadHyundaiPromiseVMFailure({ error }))),
                );
            }),
        );
    });
}
